import React from 'react';
import { Box, Icon } from '@podiumhq/design-system';

import { WiggleAnimation } from 'styles';

const AnimatedRoundedContentBox = ({
  animationBoxProps = {},
  children,
  displayLogoIcon = false,
  ...props
}) => (
  <Box
    backgroundColor="silver.lightest"
    borderRadius="16px"
    boxShadow="0 0 0 0.5px rgba(18, 21, 26, 0.08),
	0 8px 16px rgba(18, 21, 26, 0.02),
	0 16px 32px -4px rgba(18, 21, 26, 0.04),
	0 32px 64px -8px rgba(18, 21, 26, 0.04)"
    position="fixed"
    top="25%"
    width="512px"
    zIndex="10"
    {...props}
  >
    {displayLogoIcon && (
      <Icon
        boxSize={5}
        color="black.base"
        fill="black.base"
        marginBottom="24px"
        sx={{ svg: { fill: 'black.base' } }}
        type="Logo"
      />
    )}

    <WiggleAnimation {...animationBoxProps}>{children}</WiggleAnimation>
  </Box>
);

export default AnimatedRoundedContentBox;
